import React from 'react';
import { FaArrowCircleRight } from 'react-icons/fa';
import { urlWebsite } from '../../../../../../config';
import { Separator } from '../../pages/Submission/styles';

import { Container } from './style';
interface IProps {
    data: Record<string, any>;
    submission: Record<string, any>;
}

const Review: React.FC<IProps> = ({ data, submission }) => {

    const renderField = (block, sub) => {

        const hashField = block?.hash;
        if (hashField === 'categories') {

            //  return <CheckboxIncluder category={category} area={area} subarea={subarea} setSubarea={(value) => setSubarea(value)} setArea={(value) => setArea(value)} setCategory={(value) => setCategory(value)} name="category" options={sub?.categories} placeholder="Categorias" />
            return <>
                <tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>Categoria<br /></p>{data.category}</td></tr>
                {data?.area ? <tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>Área<br /></p>{data.area}</td></tr> : <></>}
                {data?.subarea ? <tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>Subárea<br /></p> {data.subarea}</td></tr> : <></>}
            </>


        }
        else if (hashField === 'resume') {

            const items: Array<JSX.Element> = [];







            const itemTitle = submission?.resume_fields?.find(i => i.hash === 'title');
            if (itemTitle) {
                items.push(<tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>{itemTitle?.title}<br /></p>{data?.title || 'Não informado'}</td></tr>);
            }


            const itemPresentationLink = submission?.resume_fields?.find(i => i.hash === 'presentation_link');
            if (itemPresentationLink) {
                items.push(<tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>{itemPresentationLink?.title}<br /></p>{data?.presentation_link || 'Não informado'}</td></tr>);
            }



            const itemResume = submission?.resume_fields?.find(i => i.hash === 'short_description');
            if (itemResume) {
                items.push(<tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>{itemResume?.title}<br /></p><p dangerouslySetInnerHTML={{ __html: data?.short_description || 'Não informado' }} /></td></tr>);
            }



            const itemPresentationImage = submission?.resume_fields?.find(i => i.hash === 'presentation_image');
            if (itemPresentationImage) {
                items.push(<tr> <td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>{itemPresentationImage?.title}<br /></p><img src={`${urlWebsite}/${data?.presentation_image}`} style={{ width: '100%' }} /></td></tr>);
            }



            const itemKeywords = submission?.resume_fields?.find(i => i.hash === 'keywords');
            if (itemKeywords) {

                let keys : Array<string> = [];
 
                data?.keywords?.map( keyValue => {
                    keys.push(keyValue?.keyword)
                })

                items.push(<tr> <td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>{itemKeywords?.title}<br /></p>{keys?.length > 0 ? keys?.join(', ') : 'Não informado'}</td></tr>);
            }








            return <>
                {items}
            </>

        }
        else if (hashField === 'extra_categories') {

            return <tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>{block?.title}<br /></p>{data?.extra_categories?.length > 0 ? data?.extra_categories?.join(', ') : 'Não informado'}</td></tr>

        }
        else if (hashField === 'language') {

            return <tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>{block?.title}<br /></p>{data?.language ? 'Sim' : 'Não'}</td></tr>


        }
        else if (hashField === 'coauthor') {

            return <tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>{block?.title}<br /></p>{data?.nested_co_authors || 'Não informado'}</td></tr>


        }
        else if (sub?.[`${hashField}_fields`]) {
            const items: Array<JSX.Element> = [];
            sub?.[`${hashField}_fields`]?.map(field => {
                items.push(<tr><td colSpan={2}><p style={{ marginTop: '10px', marginBottom: '5px', fontWeight: 700 }}>{field?.title}<br /></p> {data?.[field?.hash] || 'Não informado'}</td></tr>)
            });

            return <>{items}</>;

        }



    }

    const renderBlock = (block, number) => {


        return <Separator style={{ width: '100%' }}>
            <label>{number} - {block?.title}</label>

            <table style={{ width: '100%' }}>
                <tbody>
                    {renderField(block, submission)}
                </tbody>
            </table>


        </Separator>


    }


    const box = (dataInfo, key = '') => {
        if (!dataInfo) {
            return <></>
        }
        return <>
            {dataInfo.map(d => <aside style={{ background: '#eee', padding: '5px', margin: '5px', color: '#333', width: 'auto' }}>{key === 'self' ? d || '' : d?.[key] || ''}</aside>)}
        </>
    }

    return <Container>
        {submission?.available_blocks?.map((available, index) => {
            return renderBlock(available, index + 1);
        })}

    </Container>
}

export default Review;